import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Popover as BlueprintPopover } from '@blueprintjs/core';
import { Popover2 as BlueprintPopover2 } from '@blueprintjs/popover2';

/**
 * @deprecated we need to migrate away from this - use Popover2 instead!
 */
const Popover = props => /*#__PURE__*/React.createElement(BlueprintPopover, props);
Popover.defaultProps = {
  minimal: true,
  targetTagName: 'div',
  shouldReturnFocusOnClose: true,
  modifiers: {
    offset: {
      enabled: true,
      offset: '0, 4px'
    }
  }
};
const DEFAULT_POPOVER_MODIFIERS = {
  offset: {
    enabled: true,
    options: {
      offset: [0, 4]
    }
  }
};
export const Popover2 = ({
  minimal = true,
  targetTagName = 'div',
  shouldReturnFocusOnClose = true,
  modifiers = DEFAULT_POPOVER_MODIFIERS,
  ...rest
}) => /*#__PURE__*/React.createElement(BlueprintPopover2, _extends({
  minimal: minimal,
  targetTagName: targetTagName,
  shouldReturnFocusOnClose: shouldReturnFocusOnClose,
  modifiers: modifiers
}, rest));
export default Popover;